export function useWindowLocation(): Location {
  return window.location;
}
